module.exports = __webpack_public_path__ + "static/media/logo.249d1269.svg";